import collapsible from '../../modules/module--collapsible';

export default function() {
    collapsible.add({
        block:
            '#menu .menu-main .menu-main__item--has-children.menu-main__item--l1, #menu .menu-settings .menu-settings__item--has-children.menu-settings__item--l1',
        elToggle:
            '#menu .menu-main .menu-main__link--has-children.menu-main__link--l1, #menu .menu-settings .menu-settings__link--has-children.menu-settings__link--l1',
        elContent: '#menu .menu-main .menu-main__list--l2, #menu .menu-settings .menu-settings__list--l2',
        closeOutside: false,
        closeAny: true,
        closeOthers: true,
        breakpoint: 'laptop',
        breakpointDir: 'up',
        callbackAfterFire() {
            $('.menu-main__item--exclude .menu-main__link--has-children.menu-main__link--l1').off('click');
        },
        debug: false,
        speed: 250
    });
}
